import React from 'react';
import { CountriesSelect as CountriesSelectComponent } from '../../../../../components/CountriesSelect';
import { Country } from '../../../../../../base/interfaces/config';
import { signUpActions } from '../../../redux/slices/signUpSlice';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';

import '../styles.scss';

export const CountriesSelect = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { countries: selectedCountries },
    } = useAppSelector((state) => state.recruiterAppSignUp);
    const { countries } = useAppSelector((state) => state.recruiterApp.config);

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(signUpActions.setField({ id, value }));
    };

    return (
        <div className='razem-app__wrapper'>
            <CountriesSelectComponent
                title={__t('В какие страны трудоустраиваете работников?')}
                countries={countries}
                selectedCountries={selectedCountries}
                selectHandler={(value: Country[]) => inputChangeHandler('countries', value)}
            />
        </div>
    );
};
